/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './LoadingButton.scss';

import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { Spinner } from '@trp-beacon-ui-kit/react-communication';

/*
  In order to use the LoadingButton component, you will need to pass a `requestStatusKey`
  as props which will look up the status of the API call in `requestStatus` in the Redux store.
  For unique API calls, include in the API call a payload with a key `identifier` which will
  be appended to the end of key used in the `requestStatus` map.

  See `PdfButton` in `StatementsTable` for an example.
*/

class LoadingButton extends React.Component {
  state = {
    thisIsLoading: false
  };

  componentDidUpdate(prevProps, prevState) {
    const { requestStatus, requestStatusKey } = this.props;
    const thisIsLoading = requestStatus[requestStatusKey] === 'REQUESTED';

    if (thisIsLoading === prevState.thisIsLoading) {
      return;
    }

    window.clearTimeout(this.timeoutId);
    if (thisIsLoading) {
      this.setState({ thisIsLoading });
    } else {
      this.timeoutId = window.setTimeout(() => {
        this.setState({ thisIsLoading });
      }, 1000);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeoutId);
  }

  timeoutId = undefined;

  render() {
    const { thisIsLoading } = this.state;
    // We do not want to pass dispatch, requestStatus, or requestStatusKey as props to button
    const {
      children,
      className,
      disabled,
      dispatch, // eslint-disable-line no-unused-vars
      requestStatus, // eslint-disable-line no-unused-vars
      requestStatusKey, // eslint-disable-line no-unused-vars
      text,
      ...rest
    } = this.props;
    const buttonClassName = classnames(className, {
      loadingButtonDisabled: thisIsLoading
    });
    return (
      <button
        {...rest}
        className={buttonClassName}
        disabled={disabled || thisIsLoading}>
        <span className="loading-button-container">
          <span className={thisIsLoading ? 'children-loading' : ''}>
            {children ? children : text}
          </span>
          {thisIsLoading && (
            <div className="loader">
              <Spinner />
            </div>
          )}
        </span>
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  requestStatus: state.requestStatus
});

export default connect(mapStateToProps)(LoadingButton);
